// extracted by mini-css-extract-plugin
export var closeButton = "_3q-3";
export var header = "_3q-0";
export var link = "_3q-1";
export var retryButton = "_3q-2";